import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UsersService} from "../../../../_services/users.service";
import {GlobalStore} from "../../../../global.store";
import {take} from "rxjs";
import {
  CompanyWorkspaceService,
  PENDING_ACTION_EMAIL_NOTIFICATION_SETTINGS
} from "../../../../_services/company-workspace.service";

@Component({
    selector: 'app-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: [],
    standalone: true
})
export class RedirectComponent {
  constructor(readonly globalStore: GlobalStore,
              private router: Router,
              private route: ActivatedRoute,
              private userService: UsersService,
              private companyWorkspaceService: CompanyWorkspaceService) {
    this.globalStore.currentUser$.pipe(take(1)).subscribe((user) => {
      switch (this.route.snapshot.data['type']) {
        case 'not-found': {
          router.navigateByUrl(this.userService.getUserNotFoundUrl(user));
          return;
        }
        case 'emailNotificationSettings': {
          const destination = this.companyWorkspaceService.appendPendingAction(
            this.companyWorkspaceService.resolvePostLoginDestination(user),
            PENDING_ACTION_EMAIL_NOTIFICATION_SETTINGS
          );
          this.companyWorkspaceService.navigateToDestination(destination);
          return;
        }
      }
    })
  }
}
